export interface Configtype {
	hasborder: boolean;
	heightLight: boolean;
	enabled: boolean;
	maxDepth: number;
	production: boolean;
	onlineProduct: {
		enabled: boolean;
		gitBranchInclude: string[];
	},
	use: {
		userList: Array<{
			name: string;
			avatar: string;
		}>|[],
		userBaseLogs: Record<string,Omit<Configtype,"onlineProduct" | "use" | "production">>
	};
	img: {
		maxWidth: number;
		maxHeight: number;
	};
	base: BaseConfig;
	info: Info;
	error: ErrorType;
	success: Success;
	warning: Warning;
	equal: equalType;
}


export type BaseFunction<T>  = (content: any, title?: string | number) => void & T
export interface ErrorType extends BaseConfig {}
export interface Success extends BaseConfig {}
export interface Warning extends BaseConfig {}
export interface Info extends BaseConfig {}
export interface equalType {}
export type BaseConfig = {
	title: string | number;
	titleColor: string;
	contentColor: string;
	backgroundColor: string;
	borderColor: string;
};

export type SelectableConfig<T> = {
	[key in keyof T]?: T[key] extends object
		? SelectableConfig<T[key]>
		: T[key] | undefined;
};
type UserExtendedConfig<T extends string> = {
    [key in T] : Function & BaseFunc
}
export type BaseFunc = {
	picture: (url: any) => void;
	error: (content: any, title?: string | number) => void;
    success: (content: any, title?: string | number) => void;
    warning: (content: any, title?: string | number) => void;
    info: (content: any, title?: string | number) => void;
    equal: (content: any, title?: string | number) => void;
}
type ExtendedFunc<T extends string> = Function & UserExtendedConfig<T>
export type ReturnType<T extends string>  = {
    base: ExtendedFunc<T> | Function;
} & BaseFunc
// 创建一个泛型类型帮助函数，用于合并对象属性到函数上
export function createExtendedFunction<T>(
	func: Function,
	properties: T extends object ? T : never,
	prop?: 'base',
): BaseFunction<T> {
	const extendedFunction = func as BaseFunction<T>;
	// 遍历传入对象的属性，并将其赋值给扩展函数
	for (const key in properties) {
		if(prop){
			if (properties.hasOwnProperty(key)) {
				if (prop !== key) {
					(extendedFunction as any)[key] = properties[key];
				}
			}
		} else {
			if (properties.hasOwnProperty(key)) {
				(extendedFunction as any)[key] = function (...args:any) {
					console.log(...args);
				};
			}
		}
	}
	return extendedFunction;
}
